// ----------------------------------------------------------------------

export default function Paper() {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },

      styleOverrides: {
        root: {
          backgroundImage: 'none'
        },
        // Rust-bordered, softly glowing cards on the milky-white theme (Rajat's directive).
        outlined: {
          borderColor: 'rgba(217, 119, 87, 0.40)',
          boxShadow: '0 0 8px rgba(217, 119, 87, 0.12)'
        }
      }
    }
  };
}
